import { setPageSetInit } from "src/utils/redux/slices/linearBuyflow";
import store from "src/utils/redux/store";
import type { GoToPageOptions } from "../goto/pageSet";
import type { Direction, Page, PageSet } from "../types";

/**
 * Event hooks for pageset lifecycle. Use sparingly.
 *
 * set:page-set
 *  Called when the user navigates directly to a page set, either by psid or pathname.
 *  This may not be called if the user navigates into a page set within the SPA.
 * enter:page-set
 *  Called when the user enters a page set.
 * before:goto
 *  Called before navigating to page.
 * after:goto
 *  Called after goto operation has completed.
 */
type PageSetEvent =
  | "set:page-set"
  | "enter:page-set"
  | "before:goto"
  | "after:goto";

export type PageSetEventHandler = (
  event: PageSetEvent,
  params: GoToPageOptions & {
    direction: Direction;
    activePageSet: PageSet;
    fromPage?: Page;
    toPage?: Page;
  }
) => void;

// Event bus for allowing hooks on goto actions.
export const pageSetEvents = new Set<PageSetEventHandler>();

export const emitPageSetEvents: PageSetEventHandler = (event, params) => {
  pageSetEvents.forEach((handler) => {
    handler(event, params);
  });
};

let pageInit = false;
export function isPageSetInit() {
  return store.getState().linearBuyflow.isPageSetInit;
}
export function isPageInit() {
  return pageInit;
}

pageSetEvents.add(async (event) => {
  if (event === "enter:page-set") {
    store.dispatch(setPageSetInit(true));
  } else if (event === "set:page-set") {
    store.dispatch(setPageSetInit(false));
  } else if (event === "before:goto") {
    pageInit = true;
  }
});
